document.addEventListener("turbo:load", async() => {
  const container = document.getElementById('paymentBrick_container')
  if(container){

    const amount = document.getElementById('paymentBrick_container').dataset.amount
    const public_key = document.getElementById('paymentBrick_container').dataset.publicKey
    const email = document.getElementById('paymentBrick_container').dataset.email
    const mp = new MercadoPago(public_key, { locale: 'es-CL'})
    const bricksBuilder = mp.bricks()
    const preference_id = document.getElementById('paymentBrick_container').dataset.preference

    const renderPaymentBrick = async (bricksBuilder) => {
      const settings = {
        initialization: {
          preferenceId: preference_id,
          redirectMode: "self",
          marketplace: true,
          amount: amount,
          payer: { entityType: "individual", email: email},
        },
        customization: {
          visual: {
            hideRedirectionPanel: false,
            // hideFormTitle: true,
            style: {
              theme: "bootstrap",
              customStyle: {
                hideValueProp: true
              }
            }
          },
          paymentMethods: {
            creditCard: "all",
            debitCard: "all",
            maxInstallments: 1,
            mercadoPago: "all",
            prepaidCard: "all"
          }
        },

        callbacks: {
          onReady: () => console.log('Brick listo'),
          onSubmit: ({ selectedPaymentMethod, formData }) => {
            
            const container = document.getElementById('paymentBrick_container')
            const storeId = container.getAttribute('data-store-id')

            return new Promise((resolve, reject) => {
              const isWallet = selectedPaymentMethod?.payment_type === 'wallet_purchase';

              if (isWallet || !formData) {
                resolve(); // Brick redirigir
                return;
              }
              fetch(`/stores/${storeId}/process_payment`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                body: JSON.stringify(formData),
              })
              .then(response => response.json().then(payload => ({ ok: response.ok, payload })))
              .then(({ ok, payload }) => {
                // El carrito se revalida server-side recién en el submit: un producto
                // pudo agotarse o pausarse con el checkout ya abierto. Ahí no hay pago
                // que reportar, solo a dónde mandar al usuario. El payload trae además
                // `message`, todavía sin mostrar (ver halt_checkout en el controller).
                if (!ok && payload.status === 'cart_invalid') {
                  window.location.href = payload.redirect_url;
                  resolve();
                  return;
                }

                const paymentResult = payload;
                let redirectUrl;
                if (paymentResult.status === 'approved') {
                  let redirectUrl_base = `/stores/${storeId}/response_payment?payment_id=${paymentResult.payment_id}` 
                  redirectUrl = redirectUrl_base += '&status=approved'
                } else if (paymentResult.status === 'pending' && paymentResult.status_detail === 'pending_challenge') {
                  let redirectUrl_base = `/stores/${storeId}/response_payment?payment_id=${paymentResult.payment_id}&external_resource_url=${encodeURIComponent(paymentResult.three_ds_info.external_resource_url)}&creq=${encodeURIComponent(paymentResult.three_ds_info.creq)}`;
                  redirectUrl = redirectUrl_base += '&status=pending'
                } else {
                  let redirectUrl_base = `/stores/${storeId}/response_payment?payment_id=${paymentResult.payment_id}`;
                  redirectUrl = redirectUrl_base += '&status=rejected'
                }

                // Delivery → el "home" del pedido es /stores (ahí vive la card de
                // seguimiento). response_payment ramifica el redirect con este flag.
                if (container.dataset.delivery === 'true') {
                  redirectUrl += '&delivery=true';
                }

                window.location.href = redirectUrl;
                resolve(paymentResult)
              })              
              .catch(error => {
                console.error('Error processing payment:', error.message || 'Unknown error');
                reject(error)
              });
            });
            
          },
          onError: (error) => console.error('Error en Brick:', error),
        },
      };
      // console.log(" Settings usados:", settings)
      window.paymentBrickController = await bricksBuilder.create('payment', 'paymentBrick_container', settings);
    };

    function unmountBrick() {
      if (window.paymentBrickController) {
        window.paymentBrickController.unmount();
        window.paymentBrickController = null;
        console.log('Brick unmounted');
      }
    }

    document.addEventListener('turbo:before-visit', unmountBrick)
    window.addEventListener('beforeunload', unmountBrick)

    await renderPaymentBrick(bricksBuilder);
  }

  
});